export default [
  {
    id: 1,
    type: 'bridal',
    image: '/redlane-spa/weddings/hairdressers.jpg',
    title: 'Something Loved',
    list: [
      'Trial Hairstyling and Trail Makeup Application',
      'Hair & Makeup Application on day of wedding'
    ],
    price: 473
  },
  {
    id: 2,
    type: 'bridal',
    image: '/redlane-spa/weddings/bride.jpg',
    title: 'Something New',
    list: [
      'Trial Hairstyling and Trial Makeup Application',
      'Hair & Makeup Application on day of wedding',
      'Mindful Manicure & Pedicure'
    ],
    price: 565
  },
  {
    id: 3,
    type: 'bridal',
    image: '/redlane-spa/weddings/glow-facial.jpg',
    title: 'Lumafirm Lift & Glow Facial',
    description: 'Say “I do” with amazing skin! This exclusively formulated treatment features the latest in freeze-dried technology and facial contouring to deliver instant results that will make you look radiant. Ideal for any skin type, it is the perfect repair boost to look your absolute best.',
    list: [
    ],
    price: 565
  },
  {
    id: 11,
    type: 'grooms',
    image: '/redlane-spa/weddings/groom.jpg',
    title: 'Groom Me',
    list: [
      'Hair cut',
      'Hue-Man Manicure'
    ],
    price: 156
  },
  {
    id: 12,
    type: 'grooms',
    image: '/redlane-spa/weddings/massage-tables.jpg',
    title: 'For The Gents',
    description: 'Men need to unwind too. Includes:',
    list: [
      'Deep Relief Massage (60 min)',
      'For Him Manicure',
      'For Him Pedicure',
      'Hair cut'
    ],
    price: 285
  }
];
